export const positions = [
  {
    symbol: "CAD",
    pnl: "+10.5",
    pnlp: "+0.5%",
  },
  {
    symbol: "CAD",
    pnl: "-10.5",
    pnlp: "-0.5%",
  },
];

export const data = [
  {
    id: 1,
    name: "1D",
    content: "",
  },
  {
    id: 2,
    name: "7D",
    content: "",
  },
  {
    id: 3,
    name: "1M",
    content: "",
  },
  {
    id: 4,
    name: "3M",
    content: "",
  },
  {
    id: 5,
    name: "6M",
    content: "",
  },
  {
    id: 6,
    name: "1Y",
    content: "",
  },
];

export const pData = [
  { time: "2013-03-12", value: 1.187187},
  { time: "2013-04-19", value: 1.242405 },
  // { time: "2023-01-03", value: 250 },
  // { time: "2023-01-04", value: 130 },
  // { time: "2023-01-05", value: 160 },
  // { time: "2023-01-06", value: 170 },
  // { time: "2023-01-07", value: 190 },
  // { time: "2023-01-08", value: 250 },
  // { time: "2023-01-09", value: 330 },
  // { time: "2023-01-10", value: 460 },
  // { time: "2023-01-11", value: 500 },
  // { time: "2023-01-12", value: 620 },
  // { time: "2023-01-13", value: 730 },
  // { time: "2023-01-14", value: 560 },
  // { time: "2023-01-15", value: 770 },
  // { time: "2023-01-16", value: 800 },
  // { time: "2023-01-17", value: 850 },
  // { time: "2023-01-18", value: 930 },
  // { time: "2023-01-19", value: 850 },
  // { time: "2023-01-20", value: 700 },
  // { time: "2023-01-21", value: 600 },
  // { time: "2023-01-22", value: 550 },
  // { time: "2023-01-23", value: 490 },
  // { time: "2023-01-24", value: 430 },
  // { time: "2023-01-25", value: 370 },
  // { time: "2023-01-26", value: 300 },
  // { time: "2023-01-27", value: 700 },
  
];

export const nData = [
  { time: "2023-01-01", value: 930 },
  { time: "2023-02-01", value: 850 },
  { time: "2023-03-01", value: 800 },
  { time: "2023-04-01", value: 770 },
  { time: "2023-05-01", value: 560 },
  { time: "2023-06-01", value: 730 },
  { time: "2023-07-01", value: 620 },
  { time: "2023-08-01", value: 500 },
  { time: "2023-09-01", value: 460 },
  { time: "2023-10-12", value: 300 },
  { time: "2023-11-12", value: 250 },
  { time: "2023-12-12", value: 190 },
  { time: "2024-01-12", value: 170 },
  { time: "2024-02-12", value: 160 },
  { time: "2024-03-12", value: 130 },
  { time: "2024-04-12", value: 250 },
  { time: "2024-05-12", value: 120 },
  { time: "2024-06-12", value: 90 },
];

export const bidAskData = [
  {
    bidSize: 40,
    bidPrice: 99.5,
    askSize: 40,
    askPrice: 102,
  },
  {
    bidSize: 40,
    bidPrice: 99.5,
    askSize: 40,
    askPrice: 102,
  },
  {
    bidSize: 40,
    bidPrice: 99.5,
    askSize: 40,
    askPrice: 102,
  },
  {
    bidSize: 40,
    bidPrice: 99.5,
    askSize: 40,
    askPrice: 102,
  },
  {
    bidSize: 40,
    bidPrice: 99.5,
    askSize: 40,
    askPrice: 102,
  },
  {
    bidSize: 40,
    bidPrice: 99.5,
    askSize: 40,
    askPrice: 102,
  },
  {
    bidSize: 40,
    bidPrice: 99.5,
    askSize: 40,
    askPrice: 102,
  },
  {
    bidSize: 40,
    bidPrice: 99.5,
    askSize: 40,
    askPrice: 102,
  },
];

export const stocks = [
  {
    name: "BLS",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "CADBRY",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "CADBRY",
    price: "N10.50 (+5.0%)",
    data: nData,
    trend: "dn",
  },
  {
    name: "BLS",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "CADBRY",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "CADBRY",
    price: "N10.50 (+5.0%)",
    data: nData,
    trend: "dn",
  },
  {
    name: "BLS",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "CADBRY",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "CADBRY",
    price: "N10.50 (+5.0%)",
    data: nData,
    trend: "dn",
  },
  {
    name: "BLS",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "BLS",
    price: "N10.50 (+5.0%)",
    data: nData,
    trend: "dn",
  },
  {
    name: "CADBRY",
    price: "N10.50 (+5.0%)",
    data: nData,
    trend: "dn",
  },
  {
    name: "CADBRY",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "BLS",
    price: "N10.50 (+5.0%)",
    data: pData,
    trend: "up",
  },
  {
    name: "BLS",
    price: "N10.50 (+5.0%)",
    data: nData,
    trend: "dn",
  },
  {
    name: "BLS",
    price: "N10.50 (+5.0%)",
    data: nData,
    trend: "dn",
  },
];
